import { render } from "./SurveyInputRadio.vue?vue&type=template&id=44daf414&ts=true"
import script from "./SurveyInputRadio.vue?vue&type=script&lang=ts"
export * from "./SurveyInputRadio.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__